export const FitText2 = ({
  width,
  height,
  rows = 1,
  text,
  maxFontSize,
  isValue = false,
} = {}) => {
  if (!width) return 0
  let fontSize = 0

  if (isValue) {
    fontSize = width / (text.length > 5 ? text.length : 6)
  } else {
    fontSize = width / text.length
  }

  if (height && fontSize * rows * 1.25 > height) {
    fontSize = (height / rows) * 0.9
  }

  if (maxFontSize && fontSize > maxFontSize) {
    fontSize = maxFontSize
  }

  return fontSize
}
